import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";

const MobileNavContext = createContext({ open: false, toggle: () => {}, close: () => {} });

export function MobileNavProvider({ children }) {
    const [open, setOpen] = useState(false);
    const location = useLocation();

    // Close on route change
    useEffect(() => { setOpen(false); }, [location.pathname]);

    // Lock body scroll while the drawer is open
    useEffect(() => {
        if (open) {
            const prev = document.body.style.overflow;
            document.body.style.overflow = "hidden";
            return () => { document.body.style.overflow = prev; };
        }
    }, [open]);

    // Close on Escape
    useEffect(() => {
        const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, []);

    const toggle = useCallback(() => setOpen((v) => !v), []);
    const close = useCallback(() => setOpen(false), []);

    return (
        <MobileNavContext.Provider value={{ open, toggle, close }}>
            {children}
        </MobileNavContext.Provider>
    );
}

export const useMobileNav = () => useContext(MobileNavContext);
